import styles from './ErrorMessage.module.scss';

type ErrorMessageProps = {
    message: string;
};

export const ErrorMessage = (props: ErrorMessageProps) => (
    <div className={styles.ErrorMessage}>{props.message}</div>
);
